import React from 'react';

import { Table } from '@unimed-fesp/components';

import FadeIn from '../../atoms/FadeIn';

import TableCadastroWebHookHeader from './TableCadastroWebHookHeader';

const TableCadastroWebhook = ({ headers, body }) => {
  return (
    <FadeIn>
      <Table head={<TableCadastroWebHookHeader headers={headers} />}>
        {body}
      </Table>
    </FadeIn>
  );
};

export default TableCadastroWebhook;
